export const ACQUISITION_COUNTRY_METADATA_KEY = "acquisition_country";

const ISO_2_COUNTRY_PATTERN = /^[A-Z]{2}$/;

export function normalizeAcquisitionCountry(value) {
  if (typeof value !== "string") return null;

  const normalized = value.trim().toUpperCase();
  return ISO_2_COUNTRY_PATTERN.test(normalized) ? normalized : null;
}

export function getAcquisitionCountryMetadataFromSearch(search) {
  const params = new URLSearchParams(search || "");
  const acquisitionCountry = normalizeAcquisitionCountry(
    params.get(ACQUISITION_COUNTRY_METADATA_KEY),
  );

  return acquisitionCountry
    ? { [ACQUISITION_COUNTRY_METADATA_KEY]: acquisitionCountry }
    : {};
}
